<template>
  <ul class="seats">
    <li
      v-for="seat in seats"
      :key="seat.id"
      class="seat"
      :class="{
        'seat--me': seat.id === me?.id,
        'seat--out': !seat.inTemple,
        'seat--absent': absentPlayerIds.includes(seat.id),
      }"
    >
      <span class="seat__name">
        {{ seat.name }}<span v-if="seat.isBot" class="seat__tag">bot</span>
      </span>

      <span class="seat__stats">
        <!-- Public, and deliberately so: p2 has this round's treasure sitting
             BESIDE the tent, not inside it. Watching it grow is how you read
             whether someone is about to bolt. -->
        <span v-if="seat.inTemple" class="seat__pocket" :title="`Carrying ${seat.pocket}`">
          <i class="gem" aria-hidden="true" />{{ seat.pocket }}
        </span>
        <span v-else class="seat__banked" :class="{ 'seat__banked--caught': seat.caught }">
          {{ seat.caught ? 'caught' : 'home' }}
        </span>

        <span v-if="seat.artifacts" class="seat__artifacts" :title="`${seat.artifacts} artifacts, safe`">
          {{ seat.artifacts }}<i class="idol" aria-hidden="true" />
        </span>

        <!-- p3: you may look at someone's tent but "not to touch or count
             what is inside". Nobody knows the score until the end. -->
        <span class="seat__tent" :title="tentTitle(seat)">
          <i class="tent" aria-hidden="true" />{{ seat.id === me?.id ? seat.tent : '?' }}
        </span>
      </span>

      <span class="seat__choice" :class="choiceClass(seat)">{{ choiceLabel(seat) }}</span>
    </li>
  </ul>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { CHOICES } from '@/engine/constants';

// Everyone at the table: what they are carrying, and where they are.
//
// THE ONE RULE THIS COMPONENT EXISTS TO ENFORCE: nobody's torch-or-camp is
// shown until every single choice is in. They are written to the shared state
// one at a time as people tap, so rendering them as they arrive would hand
// the slowest decider everyone else's answer - which is the entire game. Until
// then a seat reads only "ready" or "thinking", which is exactly the
// information you have at a real table watching someone's hand hover.
export default {
  name: 'SeatList',
  computed: {
    ...mapState(['game', 'roomMeta']),
    ...mapGetters(['me', 'others', 'choicesRevealed', 'absentPlayerIds']),
    /** Me first, then everyone else round to the left. */
    seats() {
      return this.me ? [this.me, ...this.others] : this.game?.players || [];
    },
  },
  methods: {
    tentTitle(seat) {
      return seat.id === this.me?.id
        ? 'Your tent - safe'
        : 'Their tent. You can see it, but not count it.';
    },
    choiceLabel(seat) {
      if (!seat.inTemple) return '';
      if (this.absentPlayerIds.includes(seat.id) && seat.choice === null) return 'gone quiet';
      if (seat.choice === null) return 'thinking…';
      if (!this.choicesRevealed) return 'ready';
      return seat.choice === CHOICES.LEAVE ? 'leaving' : 'going on';
    },
    choiceClass(seat) {
      if (!seat.inTemple || seat.choice === null || !this.choicesRevealed) return null;
      return seat.choice === CHOICES.LEAVE ? 'seat__choice--leave' : 'seat__choice--go';
    },
  },
};
</script>
